/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 * @author Альберт Евстратов
 */
import React, { PropsWithChildren, useContext, useMemo } from "react";
import sass from "./roles.module.sass";
import Switch from "components-new/Switch";
import { newState } from "pages/RolesSetup/init";
import { RolesContext } from "pages/RolesSetup/Roles.Setup";

export type RecursiveSelectItems = RecursiveSelectItem[];

export type RecursiveSelectItem = {
	id: string;
	name: string;
	someIfsOn: Array<string> | null;
	someIfsOff: Array<string> | null;
	fields: RecursiveSelectItems | null;
};

const captions = ["dictionaries", "system", "docs", "categoryzation"];
export const realData: { [key: string]: boolean } = {
	dictionaries: false,
	okved: false,
	inapplicability_reason: false,
	activity_area: false,
	person_status: false,
	markers: false,
	object_type: false,
	threat_consequence: false,
	construction_objects: false,
	threats: false,
	significance_criteria: false,
	document_patterns: false,
	statuses_objects: false,
	ownership_type: false,
	system: false,
	docs: false,
	categoryzation: false,
	steps: false,
	step_one: false,
	step_two: false,
	step_three: false,
	step_four: false,
	step_five: false,
	step_six: false,
	step_seven: false,
	business_process_pattern: false,
	"dictionary.okved.read": false,
	"dictionary.okved.edit": false,
	"dictionary.okved.import": false,
	"dictionary.organization_marker.read": false,
	"dictionary.organization_marker.edit": false,
	"dictionary.organization_marker.import": false,
	"dictionary.threat.read": false,
	"dictionary.threat.edit": false,
	"dictionary.threat.import": false,
	"dictionary.object_status.read": false,
	"dictionary.object_status.edit": false,
	"dictionary.object_status.import": false,
	"dictionary.inapplicability_reason.read": false,
	"dictionary.inapplicability_reason.edit": false,
	"dictionary.inapplicability_reason.import": false,
	"dictionary.object_type.read": false,
	"dictionary.object_type.edit": false,
	"dictionary.object_type.import": false,
	"dictionary.significance_criteria.read": false,
	"dictionary.significance_criteria.edit": false,
	"dictionary.significance_criteria.import": false,
	"dictionary.ownership_type.read": false,
	"dictionary.ownership_type.edit": false,
	"dictionary.ownership_type.import": false,
	"dictionary.activity_area.read": false,
	"dictionary.activity_area.edit": false,
	"dictionary.activity_area.import": false,
	"dictionary.threat_consequence.read": false,
	"dictionary.threat_consequence.edit": false,
	"dictionary.threat_consequence.import": false,
	"dictionary.person_status.read": false,
	"dictionary.person_status.edit": false,
	"dictionary.person_status.import": false,
	"dictionary.construction_objects.read": false,
	"dictionary.construction_objects.edit": false,
	"dictionary.construction_objects.import": false,
	"dictionary.document_patterns.read": false,
	"dictionary.document_patterns.edit": false,
	"dictionary.user_document_patterns.read": false,
	"dictionary.user_document_patterns.edit": false,
	// "dictionary.document_patterns.import": false,
	"dictionary.business_process_pattern.read": false,
	"dictionary.business_process_pattern.edit": false,
	"dictionary.business_process_pattern.import": false,
	"system.organization.read": false,
	"system.organization.create": false,
	"system.organization.edit": false,
	"system.organization.delete": false,
	"system.user_dictionary.read": false,
	"system.user.read": false,
	"system.user.create": false,
	"system.user.edit": false,
	"system.user.delete": false,
	"system.user.employee_bind": false,
	"system.employee_dictionary.read": false,
	"system.employee.read": false,
	"system.employee.create": false,
	"system.employee.edit": false,
	"system.employee.user_bind": false,
	"document.organization_archive.read": false,
	"document.categorization_archive.read": false,
	"document.categorization.read": false,
	"document.organization.read": false,
	"document.folder.create": false,
	"document.upload": false,
	"document.archival": false,
	"document.archive.restore": false,
	"document.version.read": false,
	// 'categorization.status.read':false,
	"categorization.commission.read": false,
	"categorization.commission.edit": false,
	"categorization.commission.delete": false,
	"categorization.business_process_registry.read": false,
	"categorization.business_process_registry.print": false,
	"categorization.business_process_registry.edit": false,
	"categorization.approved_business_process_registry.upload": false,
	"categorization.object_registry.read": false,
	"categorization.object_registry.print": false,
	"categorization.object_registry.edit": false,
	"categorization.approved_object_registry.upload": false,
	"categorization.object_list.read": false,
	"categorization.object_list.edit": false,
	"categorization.object_list.print": false,
	"categorization.approved_object_list.upload": false,
	"categorization.threat_model.read": false,
	"categorization.threat_model.edit": false,
	"categorization.approved_threat_model.upload": false,
	"categorization.step_5.read": false,
	"categorization.category.assign": false,
	"categorization.location_document.delete": false,
	"categorization.approved_categorization_document.upload": false,
	"categorization.categorization_document.read": false,
	"categorization.step_6.read": false,
	"categorization.fstek_export_bundle.create": false,
	"categorization.fstek_export_bundle.read": false,
	"categorization.step_7.read": false,
	"categorization.step_7.edit": false,
};

const WrapField: React.FC<{ box: boolean; className: boolean } & PropsWithChildren> = ({
	box,
	className,
	children,
}) => {
	return box ? (
		<div className={className ? sass.box : sass.box_first}>{children}</div>
	) : (
		<React.Fragment>{children}</React.Fragment>
	);
};
interface IRecursiveRule {
	structureToRender: typeof newState;
	children: boolean;
	changeData: (keyId: string | Array<string>, value: boolean | null) => void;
	parentKey?: string;
	asaide: "left" | "right";
	box?: boolean;
}
export const RecursiveRule = ({
	structureToRender,
	children = false,
	changeData,
	asaide,
	box = false,
}: IRecursiveRule) => {
	const { data, active } = useContext(RolesContext);

	const changeDataWrapper = (id: string | Array<string>, value: boolean | null = null) => {
		changeData(id!, value);
	};

	const toggleChildren = (selected: boolean, children: any[], mode: "object" | "string" = "object") => {
		if (mode === "object") {
			children.forEach((item) => {
				if (item.fields) {
					if (item.fields?.length) {
						toggleChildren(selected, item.fields);
					}
					changeData(item.id, selected);
				}
			});
		} else {
			children.forEach((item) => {
				changeData(item, selected);
			});
		}
	};

	const changeItem = (item: RecursiveSelectItem) => {
		const selected = !data[item.id];
		//проверка родителей
		changeDataWrapper(item.id, selected);
		//включаем детей
		if (selected) {
			item.someIfsOn?.length && toggleChildren(selected, item.someIfsOn, "string");
		} else {
			item.someIfsOff?.length && toggleChildren(selected, item.someIfsOff, "string");
		}
		if (item.fields?.length) {
			toggleChildren(selected, item.fields);

			item.fields.forEach((_) => {
				if (selected) {
					_.someIfsOn?.length && toggleChildren(selected, _.someIfsOn, "string");

					_.someIfsOn?.forEach((child) => {
						const it = _.fields?.find((i) => i.id === child);
						if (it) {
							it.someIfsOn?.length && toggleChildren(selected, it.someIfsOn, "string");
						}
					});
				} else {
					_.someIfsOff?.length && toggleChildren(selected, _.someIfsOff, "string");

					_.someIfsOff?.forEach((child) => {
						const it = _.fields?.find((i) => i.id === child);
						if (it) {
							it.someIfsOff?.length && toggleChildren(selected, it.someIfsOff, "string");
						}
					});
				}
			});
		}
	};
	return (
		<>
			{asaide === "left" ? (
				<WrapField box={box} className={children}>
					{structureToRender.length
						? structureToRender.map((item, index) => {
								const isCaption = captions.includes(item.id);
								const isTitle = !!item.fields?.length;
								const disabled =
									typeof active?.system === "string" || item.id === "document.version.read"
										? !data["document.organization.read"] &&
										  !data["document.organization_archive.read"] &&
										  !data["document.categorization_archive.read"] &&
										  !data["document.categorization.read"]
										: false;
								if (!children && isCaption && index === 0) {
									return (
										item.name && (
											<React.Fragment key={item.id}>
												<div className={sass.caption}>
													{item.name}
													<Switch
														disabled={disabled}
														checked={data[item.id]}
														onChange={() => {
															changeItem(item);
														}}
													/>
												</div>
												{!!item.fields?.length && (
													<RecursiveRule
														children={false}
														box={true}
														asaide={"left"}
														structureToRender={item.fields}
														changeData={changeDataWrapper}
													/>
												)}
											</React.Fragment>
										)
									);
								} else {
									return (
										<React.Fragment key={item.id}>
											{!isTitle ? (
												<>
													<label className={sass.item}>
														{item.name}
														<Switch
															disabled={disabled}
															checked={data[item.id]}
															onChange={() => {
																changeItem(item);
															}}
														/>
													</label>
													{!!item.fields?.length && (
														<RecursiveRule
															box={true}
															children={false}
															asaide={"left"}
															structureToRender={item.fields}
															changeData={changeDataWrapper}
														/>
													)}
												</>
											) : (
												<>
													<div className={sass.title}>
														{item.name}
														<Switch
															disabled={disabled}
															checked={data[item.id]}
															onChange={() => {
																changeItem(item);
															}}
														/>
													</div>
													{!!item.fields?.length && (
														<RecursiveRule
															box={true}
															children={true}
															asaide={"left"}
															structureToRender={item.fields}
															changeData={changeDataWrapper}
														/>
													)}
												</>
											)}
										</React.Fragment>
									);
								}
						  })
						: null}
				</WrapField>
			) : (
				<WrapField box={box} className={children}>
					{structureToRender.length
						? structureToRender.map((item) => {
								const isCaption = captions.includes(item.id);
								const isTitle = !!item.fields?.length;
								const disabled =
									typeof active?.system === "string" || item.id === "document.version.read"
										? !data["document.organization.read"] &&
										  !data["document.organization_archive.read"] &&
										  !data["document.categorization_archive.read"] &&
										  !data["document.categorization.read"]
										: false;
								if (!children && isCaption) {
									return (
										item.name && (
											<React.Fragment key={item.id}>
												<div className={sass.caption}>
													{item.name}
													<Switch
														disabled={disabled}
														checked={data[item.id]}
														onChange={() => {
															changeItem(item);
														}}
													/>
												</div>
												{!!item.fields?.length && (
													<RecursiveRule
														children={false}
														box={true}
														asaide={"right"}
														structureToRender={item.fields}
														changeData={changeDataWrapper}
													/>
												)}
											</React.Fragment>
										)
									);
								} else {
									return (
										<React.Fragment key={item.id}>
											{!isTitle ? (
												<>
													<label className={sass.item}>
														{item.name}
														<Switch
															disabled={disabled}
															checked={data[item.id]}
															onChange={() => {
																changeItem(item);
															}}
														/>
													</label>
													{!!item.fields?.length && (
														<RecursiveRule
															box={true}
															children={false}
															asaide={"right"}
															structureToRender={item.fields}
															changeData={changeDataWrapper}
														/>
													)}
												</>
											) : (
												<>
													{item.name && (
														<div className={sass.title}>
															{item.name}
															<Switch
																disabled={disabled}
																checked={data[item.id]}
																onChange={() => {
																	changeItem(item);
																}}
															/>
														</div>
													)}
													{!!item.fields?.length && (
														<RecursiveRule
															box={true}
															children={true}
															asaide={"right"}
															structureToRender={item.fields}
															changeData={changeDataWrapper}
														/>
													)}
												</>
											)}
										</React.Fragment>
									);
								}
						  })
						: null}
				</WrapField>
			)}
		</>
	);
};
interface IRecursiveRuleWrapper {
	change: (keyId: string | Array<string>, value: boolean | null) => void;
}
export const RecursiveRuleWrapper: React.FC<IRecursiveRuleWrapper> = ({ change }) => {
	const [first, second] = useMemo(() => {
		const copyNewState = JSON.parse(JSON.stringify(newState));
		const left = copyNewState[0];
		copyNewState.splice(0, 1);
		return [left, copyNewState];
	}, []);

	return (
		<>
			<div className={sass.rules}>
				<RecursiveRule asaide={"left"} children={false} structureToRender={[first]} changeData={change} />
			</div>
			<div className={sass.rulesR}>
				<RecursiveRule asaide={"right"} children={false} structureToRender={second} changeData={change} />
			</div>
		</>
	);
};
